var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import { Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service.ts";
import AddCaseRemark from "~/components/collection-execution/operate-components/add-case-remark.vue";
var CollectionExecutionModule = namespace("collection-execution");
var CaseRemark = /** @class */ (function (_super) {
    __extends(CaseRemark, _super);
    function CaseRemark() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchModel = {};
        _this.dataSet = [];
        _this.dialog = {
            addCaseRemark: false
        };
        return _this;
    }
    CaseRemark.prototype.refreshData = function () {
        var _this = this;
        this.searchModel.caseId = this.caseId;
        this.caseOperatorPageService
            .caseRemark(this.searchModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    CaseRemark.prototype.activated = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(PageService)
    ], CaseRemark.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], CaseRemark.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], CaseRemark.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CaseRemark.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CaseRemark.prototype, "hiddenAction", void 0);
    CaseRemark = __decorate([
        Component({
            components: {
                AddCaseRemark: AddCaseRemark
            }
        })
    ], CaseRemark);
    return CaseRemark;
}(Vue));
export default CaseRemark;
